export const APP_COMPANY_BRANCHES = 'APP_COMPANY_BRANCHES'
export const APP_PUSH_SUBSCRIPTION_ID = 'APP_PUSH_SUBSCRIPTION_ID'
export const APP_SALES_TIME_RANGE = 'APP_SALES_TIME_RANGE'
export const APP_LAST_ORDERS_IDS = 'APP_LAST_ORDERS_IDS'
